import { useState } from "react";
import type { Incident, SimState } from "../domain/model";
import { careRequired, specialtyLabels } from "../domain/patients";
export default function PatientOverview({
  state,
  incident: i,
}: {
  state: SimState;
  incident: Incident;
}) {
  const [all, setAll] = useState(false);
  const patients = i.patients ?? [];
  if (!patients.length) return null;
  const done = patients.filter((p) => p.phase === "delivered").length;
  return (
    <section className="patient-overview" aria-label="Patienten und Transporte">
      <h3>
        Patienten & Transport{" "}
        <span className="count-badge">
          {done} / {patients.length} übergeben
        </span>
      </h3>
      <p className="muted small">
        Transportbereite Patienten werden durch RTW oder Hubschrauber in ein
        Krankenhaus gebracht. Status 7: Transport · Status 8: Übergabe.
        Fachbereiche und Belegung sind simuliert.
      </p>
      {(all ? patients : patients.slice(0, 6)).map((p) => {
        const v = state.vehicles.find((v) => v.id === p.vehicleId),
          h = state.hospitals?.find((h) => h.id === p.hospitalId);
        return (
          <div key={p.id} className={"patient-row " + p.severity}>
            <div>
              <strong>{p.label}</strong>
              <span>
                {p.severity === "critical" ? "kritisch" : "stabil"} ·{" "}
                {specialtyLabels[p.specialty]}
              </span>
            </div>
            <b>
              {p.phase === "waiting"
                ? p.careSeconds >= careRequired(p)
                  ? "Transportbereit · Fahrzeug/Ziel ausstehend"
                  : "Versorgung " +
                    Math.min(
                      100,
                      Math.floor((p.careSeconds / careRequired(p)) * 100),
                    ) +
                    " %"
                : p.phase === "transport"
                  ? v?.kind === "RTH" || v?.kind === "ITH"
                    ? "Flug zum Krankenhaus"
                    : "Fahrt zum Krankenhaus"
                  : p.phase === "handover"
                    ? "Patientenübergabe"
                    : "Übergeben"}
            </b>
            {v && <small>{v.name}</small>}
            {h && (
              <a href={h.sourceUrl} target="_blank" rel="noreferrer">
                {h.name} ↗
              </a>
            )}
          </div>
        );
      })}
      {patients.length > 6 && (
        <button className="text-button" onClick={() => setAll(!all)}>
          {all
            ? "Weniger anzeigen"
            : "Alle " + patients.length + " Patienten anzeigen"}
        </button>
      )}
      {!state.hospitals?.length && (
        <p className="form-error">
          Keine Krankenhausziele geladen. Transporte warten auf einen
          verfügbaren Zielbestand.
        </p>
      )}
    </section>
  );
}
